module.exports = __webpack_public_path__ + "img/alexis-henderson.186efd09.png";